import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../../components/Layout';

import '../../assets/scss/challenge.scss';

const Start = (props) => {
   const pathname = useLocation().pathname.substring(1);
   const isStudy = pathname.startsWith('Study');
   const [count, setCount] = useState(10); // Default 10 words

   const handleChange = (e) => {
      // Only allow numbers
      const value = e.target.value.replace(/[^0-9]/g, '');
      setCount(value);
   };
   // 1~100 (server also caps it)
   const safeCount = Math.min(Math.max(parseInt(count) || 10, 1), 100);

   return (
      <Layout header containName='start'>
         <strong className="start-text">
            {pathname.startsWith('Challenge') && (<>오늘은</>)}
            <input
               type="text"
               value={count}
               onChange={handleChange}
               style={{ width: '80px', textAlign: 'center' }}
               placeholder="10"
            />
            {isStudy ? (<>단어<br />공부해볼까?</>) : (<>문항으로<br />챌린지 시작해볼까?</>)}
         </strong>

         <Link
            to={isStudy ? `/Study/View?count=${safeCount}` : `/Challenge/View?count=${safeCount}`}
            className="btn btn-white"
         >
            START
         </Link>

         {isStudy && (
            <Link to="/Study/Curriculum" style={{ display: 'block', marginTop: '16px', color: '#fff', textAlign: 'center', textDecoration: 'underline' }}>
               Day별로 학습하기
            </Link>
         )}

      </Layout>
   );
};

export default Start;